const SMU_TOKEN = "smu-token";
const SMU_USER = "smu-user";
const ITEMS_PER_PAGE = 10;
const SKIRTS_ID = 0;

export { SMU_TOKEN, SMU_USER, ITEMS_PER_PAGE, SKIRTS_ID};
